
import React, { useState, useEffect } from 'react';
import { Typography, Box, TextField, Button, Grid, CircularProgress } from '@material-ui/core';
import useStyles from "./PatientProfile.style";
import TimelineIcon from '@material-ui/icons/Timeline';
import EditIcon from "@material-ui/icons/Edit";
import SearchIcon from "@material-ui/icons/Search";
import { useParams } from 'react-router-dom';
import { EllipseButton } from '../components/DesktopInput.component';
import { Link } from 'react-router-dom';
import PatientProfilePersonalInformation from './PatientProfilePersonalInformation.component';
import PatientProfilePregnancy from './PatientProfilePregnancy.component';
import PatientProfileStepChildren from './PatientProfileStepChildren.component';
import PatientProfileContraception from './PatientProfileContraception.component';
import PatientProfileFertilityTreatment from './PatientProfileFertilityTreatment.component';
import PatientProfileAdoptions from './PatientProfileAdoption.component';
import PatientProfileChildrenLoss from './PatientProfileChildrenLoss.component';
import PatientProfileFertilityPreservation from './PatientProfileFertilityPreservation.component';
import PatientProfileCancerDiagnosisAndTreatment from './PatientProfileCancerDiagnosisAndTreatment.component';
import Cookies from 'universal-cookie';
import CryptoJS from 'crypto-js'
import { useTranslation } from 'react-i18next';
import Alert from '@material-ui/lab/Alert';
import PatientFamilyHistory from './PatientFamilyHistory.component';

const cookies = new Cookies();

const PatientProfile = props => {

    const classes = useStyles();
    const { t } = useTranslation();
    const { patientId } = useParams();

    const [profile, setProfile] = useState(false);
    const [dateOfBirth, setDateOfBirth] = useState(false);
    const [dateOfBirthYear, setDateOfBirthYear] = useState();
    const [pregnancies, setPregnancies] = useState([]);
    const [stepchildrens, setStepchildren] = useState([]);
    const [contraceptions, setContraception] = useState([]);
    const [fertilityTreatments, setFertilityTreatments] = useState([]);
    const [adoptions, setAdoptions] = useState([]);
    const [childrenLoss, setChildrenLoss] = useState([]);
    const [fertilityPreservation, setFertilityPreservation] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const [isSearchResultEmpty, setIsSearchResultEmpty] = useState(false);

    const [inputText, setInputText] = useState("");
    const [anyCancerDiagnosis, setCancerDiagnosis] = useState('');
    const [anyWaitingCancerDiagnosis, setWaitingCancerDiagnosis] = useState('');
    const [pendingCancerDiagnosis, setPendingCancerDiagnosis] = useState('');
    const [otherPendingCancerDiagnosis, setOtherPendingCancerDiagnosis] = useState('');
    const [currentSiteOfCancer, setCurrentSiteOfCancer] = useState('');
    const [cancerDiagnosisAndTreatments, setCancerDiagnosisAndTreatments] = useState([]);

    // Family history properties
    const [fhGeneralDiseases, setFhGeneralDiseases] = useState([]);
    const [fhBehavioral, setFhBehavioral] = useState([]);
    const [fhCardiovascular, setFhCardiovascular] = useState([]);
    const [fhEndocrine, setFhEndocrine] = useState([]);
    const [fhGastrointestinal, setFhGastrointestinal] = useState([]);
    const [fhHematologic, setFhHematologic] = useState([]);
    const [fhImmunologic, setFhImmunologic] = useState([]);
    const [fhNeurologic, setFhNeurologic] = useState([]);
    const [fhOncologic, setFhOncologic] = useState([]);
    const [fhPsychiatric, setFhPsychiatric] = useState([]);
    const [fhRespiratory, setFhRespiratory] = useState([]);
    const [fhReproductive, setFhReproductive] = useState([]);

    const [isAuthenticate, setAuthenticated] = useState(false);
    const [password, setPassword] = useState('');
    const [passwordSending, setPasswordSending] = useState(false);
    const [error, setError] = useState('');

    let inputHandler = (e) => {
        setUsersList([])
        setIsSearchResultEmpty(false);
        setInputText(e.target.value);
    };

    let onSearchIconClick = async () => {
        setUsersList([])
        try {
            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER}/search/${inputText}`, {
                headers: {
                    'X-ACCESS-TOKEN': cookies.get('token')
                }
            });
            if (!response.ok) {
                return;
            };
            let result = await response.json();
            let patients = result.map(x => {
                return {
                    _id: x.user._id,
                    firstName: x.user.firstName,
                    lastName: x.user.lastName,
                    email: x.user.email,
                    dateOfBirth: (new Date(x.dateOfBirth)).toLocaleDateString()
                }
            });
            if (patients.length > 0) {
                setUsersList(patients)
            }
            else {
                setUsersList([])
                setIsSearchResultEmpty(true);
            }
        }
        catch (error) {
            console.log(error)
        }
    };


    useEffect(() => {
        if (isAuthenticate) {
            const getPatientData = async () => {
                try {
                    let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_PATIENT_PROFILE}/${patientId}`, {
                        headers: {
                            'X-ACCESS-TOKEN': cookies.get('token')
                        }
                    });
                    if (!response.ok) {
                        return;
                    };
                    let profile = await response.json();
                    // dropdownusers 
                    setUsersList([])
                    setInputText("");
                    setProfile(profile)
                    setPregnancies(profile.pregnancies)
                    let dob = new Date(profile.dateOfBirth);
                    setDateOfBirth(dob.toLocaleDateString());
                    setDateOfBirthYear(dob.getFullYear());
                    setStepchildren(profile.stepchildren);
                    setContraception(profile.contraception);
                    setFertilityTreatments(profile.fertilityTreatment);
                    setAdoptions(profile.adoptions);
                    setChildrenLoss(profile.childrenLoss);
                    setFertilityPreservation(profile.fertilityPreservation);
                    setCancerDiagnosis(profile.anyCancerDiagnosis);
                    setWaitingCancerDiagnosis(profile.anyWaitingCancerDiagnosis);
                    setPendingCancerDiagnosis(profile.pendingCancerDiagnosis);
                    setOtherPendingCancerDiagnosis(profile.otherPendingCancerDiagnosis);
                    setCurrentSiteOfCancer(profile.currentSiteOfCancer);
                    setCancerDiagnosisAndTreatments(profile.cancers);
                    setFhGeneralDiseases(profile.fhGeneral);
                    setFhBehavioral(profile.fhBehavioral);
                    setFhCardiovascular(profile.fhCardiovascular);
                    setFhEndocrine(profile.fhEndocrine);
                    setFhGastrointestinal(profile.fhGastrointestinal);
                    setFhHematologic(profile.fhHematologic);
                    setFhImmunologic(profile.fhImmunologic);
                    setFhNeurologic(profile.fhNeurologic);
                    setFhOncologic(profile.fhOncologic);
                    setFhPsychiatric(profile.fhPsychiatric);
                    setFhRespiratory(profile.fhRespiratory);
                    setFhReproductive(profile.fhReproductive);
                }
                catch (error) {
                    console.log(error)
                }
            }
            getPatientData();
        }
    }, [patientId, isAuthenticate]);


    const handlePasswordSubmit = async e => {
        e.preventDefault();
        let email = localStorage.getItem('email');
        const bytes = CryptoJS.AES.decrypt(email, process.env.REACT_APP_SECRET_KEY);
        const decryptEmail = bytes.toString(CryptoJS.enc.Utf8);
        setPasswordSending(true);

        try {
            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERIFY_PROVIDER_EMAIL}`, {
                method: 'post',
                body: new URLSearchParams({
                    email: decryptEmail,
                    password: password
                })
            });
            if (!response.ok) {
                setError(t('signIn.passwordErrorMessage'));
                return;
            };
            setError(null);
            let json = await response.json();
            setAuthenticated(json.isAuthenticated);
        } catch (error) {
            console.log(error.message);
            setError(t('signIn.errorMessage'));
        } finally {
            setPasswordSending(false);
        };
    };

    


    return (
        <>
        {
            error ? <Alert severity="error">{error}</Alert> : null
        }
            {
                isAuthenticate &&
                <Box xl={12} md={12} sm={12} xs={12} >
                    <Box style={{ display: "flex", justifyContent: "space-between" }}>
                        <Box>
                            <Typography variant='h5'>
                                <b>User Profile Page</b>
                            </Typography>
                        </Box>
                        <Box>
                            <EllipseButton variant="contained"
                                color="primary"
                                size="large"
                                component={Link}
                                to={`/provider/repli/${patientId}`}
                                style={{ margin: 0 }}>
                                View RepLi
                                <TimelineIcon style={{ marginLeft: 20 }} />
                            </EllipseButton>
                        </Box>
                        <Box>
                            <EllipseButton variant="contained"
                                color="secondary"
                                size="large"
                                component={Link}
                                to={`/provider/patient/${patientId}`}>
                                Modify profile
                                <EditIcon style={{ marginLeft: 20 }} />
                            </EllipseButton>
                        </Box>
                        <Box style={{ width: "30%" }}>
                            <TextField
                                className="inputRounded"
                                style={{ width: "100%" }}
                                value={inputText}
                                onChange={inputHandler}
                                variant="outlined"
                                placeholder="Search for other patient"
                                size="small"
                                onKeyPress={(e) => {
                                    if (e.key == "Enter") {
                                        onSearchIconClick()
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <SearchIcon
                                            onClick={onSearchIconClick}
                                            style={{
                                                color: "rgb(31,161,157)",
                                                marginRight: "10px", cursor: "pointer"
                                            }} />
                                    )
                                }}
                            />
                            <Box style={{
                                position: "absolute",
                                backgroundColor: "#ffff",
                                color: "black",
                                zIndex: 1000,
                                minWidth: "30%",
                                maxWidth: "25%",
                            }}>
                                {usersList.map((user) => {
                                    return (
                                        <div className="customdropdown" style={{ margin: "5px", cursor: "pointer" }}>

                                            <Button style={{ textTransform: 'none' }}
                                                fullWidth
                                                component={Link}
                                                to={`/provider/patient/profile/${user._id}`}>
                                                {user.firstName + " " + user.lastName + " " + user.dateOfBirth}
                                            </Button>
                                        </div>)
                                })}

                                {isSearchResultEmpty &&
                                    <div className="customdropdown" style={{ margin: "5px", cursor: "pointer" }}>

                                        <Button style={{ textTransform: 'none' }}
                                            fullWidth
                                            component={Link}
                                        >
                                            No users found
                                        </Button>
                                    </div>
                                }
                            </Box>

                        </Box>

                    </Box>

                    <Box style={{ position: "relative", marginBottom:'20px' }}>

                        <PatientProfilePersonalInformation
                            dateOfBirthYear={dateOfBirthYear}
                            dateOfBirth={dateOfBirth}
                            profile={profile}>
                        </PatientProfilePersonalInformation>

                        <PatientProfilePregnancy
                            dateOfBirthYear={dateOfBirthYear}
                            pregnancies={pregnancies}>
                        </PatientProfilePregnancy>

                        <PatientProfileStepChildren
                            dateOfBirthYear={dateOfBirthYear}
                            stepChildrens={stepchildrens}>
                        </PatientProfileStepChildren>

                        <PatientProfileContraception
                            dateOfBirthYear={dateOfBirthYear}
                            contraceptions={contraceptions}>
                        </PatientProfileContraception>

                        <PatientProfileFertilityTreatment
                            dateOfBirthYear={dateOfBirthYear}
                            fertilityTreatments={fertilityTreatments}>
                        </PatientProfileFertilityTreatment>

                        <PatientProfileFertilityPreservation
                            dateOfBirthYear={dateOfBirthYear}
                            fertilityPreservations={fertilityPreservation}>
                        </PatientProfileFertilityPreservation>

                        <PatientProfileAdoptions
                            dateOfBirthYear={dateOfBirthYear}
                            adoptions={adoptions}>
                        </PatientProfileAdoptions>

                        <PatientProfileChildrenLoss
                            dateOfBirthYear={dateOfBirthYear}
                            childrenLoss={childrenLoss}>
                        </PatientProfileChildrenLoss>

                        <PatientFamilyHistory
                            fhGeneralDiseases={fhGeneralDiseases}
                            fhBehavioral={fhBehavioral}
                            fhCardiovascular={fhCardiovascular}
                            fhEndocrine={fhEndocrine}
                            fhGastrointestinal={fhGastrointestinal}
                            fhHematologic={fhHematologic}
                            fhImmunologic={fhImmunologic}
                            fhNeurologic={fhNeurologic}
                            fhOncologic={fhOncologic}
                            fhPsychiatric={fhPsychiatric}
                            fhRespiratory={fhRespiratory}
                            fhReproductive={fhReproductive}>
                        </PatientFamilyHistory>

                        <PatientProfileCancerDiagnosisAndTreatment
                            anyCancerDiagnosis={anyCancerDiagnosis}
                            anyWaitingCancerDiagnosis={anyWaitingCancerDiagnosis}
                            pendingCancerDiagnosis={pendingCancerDiagnosis}
                            otherPendingCancerDiagnosis={otherPendingCancerDiagnosis}
                            currentSiteOfCancer={currentSiteOfCancer}
                            cancerDiagnosisAndTreatments={cancerDiagnosisAndTreatments}>
                        </PatientProfileCancerDiagnosisAndTreatment>

                    </Box>
                </Box>
            }

            {/* Password Protected */}
            {!isAuthenticate &&
                <Grid container>
                    <Grid item xs={12}>
                        <Box style={{ marginTop: "20px" }}>
                            <Typography variant="h5" className='mt-5' >Password Protected Page</Typography>
                            <Typography className='mt-5' >This content is password protected. To view it please enter your password below </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        <form noValidate onSubmit={handlePasswordSubmit}>
                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="password"
                                        label="password"
                                        type="password"
                                        id="password"
                                        onChange={e => setPassword(e.target.value)}
                                        value={password}
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <Button
                                        style={{ marginTop: "25px" }}
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        className={classes.submit}
                                        disabled={passwordSending}
                                    >
                                        Enter
                                        {passwordSending && <CircularProgress size={24} className={classes.buttonProgress} />}
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Grid>
                </Grid>

            }

        </>
    )
}


export default PatientProfile;